import { clearThemePackSessions } from "@utils/onboarding/themePackStorage";
import { clearThemePackLandingIdCookie } from "@utils/onboarding/adSourceCookie.client";
import { authCacheManager } from "@features/auth/compat/auth-cache-compat";
import { clearEdgenOnboardingStepCookie } from "@utils/onboarding";
import { favoritesCenter } from "../favorite";
import { UserStore } from "./user";

/**
 * 清除登出后不应残留的业务态 —— 与 token 清理（`sessionCore.clear()`）解耦。
 *
 * 两处消费：
 * - `AuthOrchestrator.logout()`：用户主动登出
 * - `LoginStore` 冷启动发现无有效凭证时的兜底清理
 *
 * 不触碰 `LoginStore` 自身字段：那些由 `login-store-bridge` 从 authStore 单向同步。
 * 本模块也刻意不写登出标记 —— 冷启动兜底不是登出，写标记会误伤后续正常恢复。
 */
export function clearBusinessStateOnLogout(): void {
  clearThemePackSessions();
  if (UserStore.ownerInfo?.id) {
    clearThemePackLandingIdCookie();
  }
  authCacheManager.clearAllCache();
  clearEdgenOnboardingStepCookie();
  UserStore.clearUser?.();
  favoritesCenter.setCurrentUserId(null);
}
